import httpClient from "@/http-client";

export const get = (options = {}) => {
    return httpClient
        .get("/api/daily-closeouts", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const show = (id) => {
    return httpClient
        .get(`/api/daily-closeouts/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const update = (id, data) => {
    return httpClient
        .put(`/api/daily-closeouts/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const destroy = (id, data) => {
    return httpClient
        .put(`/api/daily-closeouts/${id}/delete`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const clearCash = data => {
    return httpClient
        .post("/api/daily-closeouts/clear-cash", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const createResources = options => {
    return httpClient
        .get("/api/daily-closeouts/collection-summaries", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const fetchCoRepayments = options => {
    return httpClient
        .get("/api/daily-closeouts/co-repayments", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export default {
    get,
    show,
    update,
    destroy,
    clearCash,
    createResources,
    fetchCoRepayments
};
